export default __webpack_public_path__ + "assets/images/a34570f87b076eeeca7d6e7c153d8e72.png";